export default __webpack_public_path__ + "static/media/Bluemercurry.41c9c415.PNG";